import {
	ICreateSubCategoryValidationError,
	IServerError,
	TFileId,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
} from 'types';
import {
	TVisibleForm,
	TSelectedItem,
	TTypeOfModalWindow,
} from './createSubcategoryModalState/createSubcategoryModalContext';

export enum CreateSubcategoryModalActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE_ID = 'SET_FILE_ID',
	CHANGE_NAME_OF_SUBCATEGORY = 'CHANGE_NAME_OF_SUBCATEGORY',
	SET_ID_SELECTED_CATEGORY = 'SET_ID_SELECTED_CATEGORY',
	CHANGE_SUBCATEGORY_VISIBILITY_STATUS = 'CHANGE_SUBCATEGORY_VISIBILITY_STATUS',
	CHANGE_AVAILABLE_FOR_REPETITION = 'CHANGE_AVAILABLE_FOR_REPETITION',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	SET_FETCHED_TRANSLATIONS = 'SET_FETCHED_TRANSLATIONS',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	INITIAL_DATA = 'INITIAL_DATA',
}

interface IChangeVisibleForm {
	type: CreateSubcategoryModalActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TVisibleForm;
	};
}

interface ISetFileId {
	type: CreateSubcategoryModalActionTypes.SET_FILE_ID;
	payload: {
		fileId: TFileId;
	};
}

interface IChangeNameOfSubCategory {
	type: CreateSubcategoryModalActionTypes.CHANGE_NAME_OF_SUBCATEGORY;
	payload: {
		nameOfSubCategory: string;
	};
}

interface ISetIDSelectedCategory {
	type: CreateSubcategoryModalActionTypes.SET_ID_SELECTED_CATEGORY;
	payload: {
		IDSelectedCategory: TSelectedItem;
	};
}

interface IChangeSubCategoryVisibilityStatus {
	type: CreateSubcategoryModalActionTypes.CHANGE_SUBCATEGORY_VISIBILITY_STATUS;
	payload: {
		isHiddenSubCategory: boolean;
	};
}

interface IChangeAvailableForRepetition {
	type: CreateSubcategoryModalActionTypes.CHANGE_AVAILABLE_FOR_REPETITION;
	payload: {
		isAvailableForRepetition: boolean;
	};
}

interface ISetTranslationTab {
	type: CreateSubcategoryModalActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: Nullable<TLanguageIDs>;
	};
}

interface ISetFetchedTranslation {
	type: CreateSubcategoryModalActionTypes.SET_FETCHED_TRANSLATIONS;
	payload: {
		translations: IMenuTranslation[];
		defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	};
}

interface IChangeTranslation {
	type: CreateSubcategoryModalActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateSubcategoryModalActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IShowErrorModalWithInfo {
	type: CreateSubcategoryModalActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IServerError<ICreateSubCategoryValidationError> | null;
	};
}

interface IInitialData {
	type: CreateSubcategoryModalActionTypes.INITIAL_DATA;
	payload: {
		IDCustomer: TSelectedItem;
		IDRestaurant: TSelectedItem;
	};
}

export type TCreateSubcategoryModalAction =
	| IChangeVisibleForm
	| ISetFileId
	| IChangeNameOfSubCategory
	| ISetIDSelectedCategory
	| IChangeSubCategoryVisibilityStatus
	| IChangeAvailableForRepetition
	| ISetTranslationTab
	| ISetFetchedTranslation
	| IChangeTranslation
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| IInitialData;
